module.exports = require("@absolunet/fss");